module.exports = __webpack_public_path__ + "media/src/assets/Images/SelectedRadioButton-7f8d4afb149fc2df7e9900ec251eb590.svg";